module.exports = __webpack_public_path__ + "img/logo.4a482c84.gif";